import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
import { isBot } from '@helpers/is-bot';
export var CommonsContext = createContext(undefined);
export var CommonsProvider = function (_a) {
    var children = _a.children;
    var _b = useState({}), variables = _b[0], setVariables = _b[1];
    var isBotUser = isBot(navigator.userAgent);
    var value = { variables: variables, setVariables: setVariables, isBotUser: isBotUser };
    return _jsx(CommonsContext.Provider, { value: value, children: children });
};
